import { Component, inject, OnDestroy, signal, viewChild } from '@angular/core';

import { ComponentType } from '@angular/cdk/portal';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FeatureFormComponent } from '@partners/forms';
import { DialogRef, IAlertConfig, IConfirmConfig, IDialogConfig, IGuideConfig, ITooltipConfig } from '@partners/ui';
import { TrackPageLifeCycleDirective } from '@partners/worker';
import { DialogAdapter } from '../../../dialogs';
import { NavigationAdapter } from '../../../navigation';

/**
 * @description
 * a base feature-view component, this component meant to be inherited by each features' main view.
 * it provides shortcuts access to common view behaviors, such as dialog type launch methods etc'
 */

@Component({
  standalone: true,
  template: '',
  imports: [TrackPageLifeCycleDirective],
  hostDirectives: [CdkScrollable, TrackPageLifeCycleDirective]
})
export class BaseFeatureView implements OnDestroy {
  protected _navAdapter = inject(NavigationAdapter);
  protected _dialogAdapter = inject(DialogAdapter);

  readonly isPendingSubmit = signal<boolean>(false);

  /** resolves the nearest FeatureFormComponent in the view — used to read isPending for submit-button disabled state */
  readonly featureForm = viewChild(FeatureFormComponent);

  constructor() {}

  ngOnDestroy(): void {}

  protected navigateBack() {
    this._navAdapter.moveBack();
  }

  protected openDialog<T>(component: ComponentType<T>, dialogConfig?: IDialogConfig): DialogRef {
    return this._dialogAdapter.open(component, dialogConfig);
  }

  protected openTooltip(tipConfig: ITooltipConfig): DialogRef {
    return this._dialogAdapter.openTooltip(tipConfig);
  }

  protected openAlert(alertConfig: IAlertConfig): DialogRef {
    return this._dialogAdapter.openAlert(alertConfig);
  }

  protected openGuide(guideConfig: IGuideConfig): DialogRef {
    return this._dialogAdapter.openGuide(guideConfig);
  }

  protected openConfirm(confirmConfig: IConfirmConfig): DialogRef {
    return this._dialogAdapter.openConfirm(confirmConfig);
  }
}
